// extracted by mini-css-extract-plugin
export default {"form":"SignUp_form__w5YT4","warn":"SignUp_warn__Sm-ZX","message":"SignUp_message__+RWST"};